module.exports = __webpack_public_path__ + "img/15-eng.42a3bd78.png";